import { BreadcrumbDirection, Choice, ChoiceGroup } from 'types/models';
import { MenuChoiceSelector } from 'menu/components/MenuModal/ModalComponents/MenuChoiceSelector';
import { SelectedNestedChoiceInfo } from 'menu/components/MenuModal/ModalComponents/SelectedNestedChoiceInfo';
import { useMenuModal } from 'contexts/MenuModalContext';

interface MenuChoiceProps {
  choice: Choice;
  choiceGroup: ChoiceGroup;
  choiceGroupIndex: number;
  choiceIndex: number;
  isNestedChoice?: boolean;
  itemsInChoiceGroup: number;
  portionId: number;
  updateChoice: (
    choiceIndex: number,
    choiceGroupIndex: number,
    quantity?: number,
    hasNestedChoice?: boolean,
  ) => void;
}

export const MenuChoice: React.FC<MenuChoiceProps> = ({
  choice,
  choiceGroup,
  choiceGroupIndex,
  choiceIndex,
  isNestedChoice = false,
  itemsInChoiceGroup,
  portionId,
  updateChoice,
}) => {
  const { breadcrumbs, setBreadcrumbs, setDirection } = useMenuModal();

  const productToUse = choice.productToUse;
  const choiceToUse = choice.choiceId ? choice.choiceGroup : undefined;

  const handleEditNestedChoice = () => {
    const selectedChoiceGroup = choiceGroup.choices[choiceGroupIndex];
    const selectedChoiceName =
      selectedChoiceGroup?.displayRecordToUse?.name ||
      selectedChoiceGroup?.productToUse?.eposName;
    const breadcrumbTrack = {
      choiceIndex: choiceIndex,
      choiceGroupIndex: choiceGroupIndex,
      choiceName: selectedChoiceName,
      portionId: portionId,
      portionRatios: choiceGroup.portionRatios,
    };
    setDirection(BreadcrumbDirection.Forward);
    setBreadcrumbs([...breadcrumbs, breadcrumbTrack]);
  };

  if (!productToUse && !choiceToUse) {
    return null;
  }

  return (
    <div>
      <div
        className="choice-row"
        data-testid={`choice-option-${choiceGroup.id}`}
      >
        <MenuChoiceSelector
          choice={choice}
          updateChoice={updateChoice}
          choiceIndex={choiceIndex}
          choiceGroup={choiceGroup}
          choiceGroupIndex={choiceGroupIndex}
          portionId={portionId}
          numberOfChoices={itemsInChoiceGroup}
          isNestedChoice={isNestedChoice}
        />
      </div>
      <SelectedNestedChoiceInfo
        productToUse={productToUse}
        choiceToUse={choiceToUse}
        choiceGroup={choiceGroup}
        choice={choice}
        portionId={portionId}
        handleEditNestedChoice={handleEditNestedChoice}
      />
    </div>
  );
};
